/** NL Ella-chat preview opt-in. Reveals the Ella chat launcher for one visitor
 *  in the Dutch market via a `?ella-nl=<ELLA_NL_PREVIEW_TOKEN>` magic link,
 *  BEFORE `feature:chat` is widened to include `nl` in the country-gate registry.
 *
 *  Distinct from `nl-preview` (the `NL_STATUS` route/token gate that hides the
 *  not-yet-public `/nl/*` tree): NL is already live and public (waitlist), so
 *  that gate is off — this only unlocks the not-yet-launched chat widget. NL is
 *  bilingual, so this reveals the launcher on both `/nl/nl/*` and `/nl/en/*`;
 *  the layout mount keys on country, not locale, so one token covers both.
 *  Mirrors lib/ella-de-preview.ts. */
export const ELLA_NL_PREVIEW_TOKEN_COOKIE = "ella-nl-preview"
export const ELLA_NL_PREVIEW_ACTIVE_COOKIE = "ella-nl-preview-active"
export const ELLA_NL_PREVIEW_PARAM = "ella-nl"

/** True when the visitor opted into the NL Ella-chat preview. Client-only —
 *  reads `document.cookie`, returns false during SSR so it never forces a page
 *  dynamic (the launcher is `ssr:false` and mounts post-hydration anyway). */
export function hasEllaNlPreviewActive(): boolean {
  if (typeof document === "undefined") return false
  return document.cookie
    .split("; ")
    .includes(`${ELLA_NL_PREVIEW_ACTIVE_COOKIE}=1`)
}
